import { usePermission } from "./permissionProvider";

export const useAccess = (
  resource: string,
  permission: string,
  actions: string[]
): boolean => {
  const { hasAction, loading } = usePermission();

  // While loading, do NOT deny — wait until loaded
  if (loading) return false;

  // User has access if ANY action matches
  return actions.some(action => hasAction(resource, permission, action));
};
